<template>
    <v-card>
        <v-card-title>
            <search v-model="search"/>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="openAdd" v-if="userIsFleetManager">Add</v-btn>
            <v-dialog persistent v-model="dialog" max-width="500px">
                <Form
                    v-model="model"
                    @add="submitAdd($event.id, $event.model)"
                    @edit="submitUpdate($event.model)"
                    :service-requirements="serviceRequirements"
                    :container-sizes="containerSizes"
                >
                    <template v-slot:header>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog=false" icon text>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:actions>
                        <v-btn @click="dialog=false">Cancel</v-btn>
                    </template>
                </Form>
            </v-dialog>
        </v-card-title>

        <v-data-table
            :items="configurations"
            :items-per-page="options.itemsPerPage"
            :headers="headers"
            :search="search"
            :loading="$wait.is(['loading configurations'])"
            :footer-props.sync="footerProps"
            :options.sync="options"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr @click="userIsFleetManager ? openEdit(props.item) : null">
                    <td>{{props.item.name}}</td>
                    <td>{{props.item.type}}</td>
                    <service-requirements-chip-list
                        v-bind:serviceRequirements="serviceRequirementsForConfiguration(props.item)"
                    ></service-requirements-chip-list>
                    <container-sizes-chip-list
                        v-bind:containerSizes="containerSizesForConfiguration(props.item)"
                    ></container-sizes-chip-list>
                    <td width="76px" class="pl-0" v-if="userIsFleetManager">
                        <v-btn @click="openEdit(props.item)" icon>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
  import Form from './Form.vue';
  import Search from '../Search.vue';
  import ServiceRequirementsChipList from '../ServiceRequirements/ChipList.vue';
  import ContainerSizesChipList from '@/components/Containers/ChipList.vue';
  import ServiceRequirements from '../ServiceRequirements/ServiceRequirementsClient.vue';
  import Configurations from '../Configurations/ConfigurationsClient.vue';
  import Container from '@/components/Containers/ContainersClient';

  export default {
    components: {
      Form,
      Search,
      ServiceRequirementsChipList,
      ContainerSizesChipList
    },
    mixins: [ServiceRequirements, Configurations, Container],
    data() {
      return {
        configurations: [],
        serviceRequirements: [],
        containerSizes: [],
        dialog: false,
        search: '',
        loading: true,
        options: {
          itemsPerPage: 50,
          sortBy: ['name']
        },
        footerProps: {
          itemsPerPageOptions: [10, 50, 100]
        },
        headers: [
          {text: 'Name', value: 'name'},
          {text: 'Type', value: 'type'},
          {text: 'Service Requirements', value: 'serviceRequirements'},
          {text: 'Container Sizes', value: 'containerSizes'}],
        model: {}
      };
    },
    methods: {
      openAdd() {
        this.model = {};
        this.dialog = true;
      },
      openEdit(config) {
        this.model = {...config}; // spread operator intentionally used to create clone
        this.dialog = true;
      },
      async submitAdd(id, model) {
        const result = await this.addConfiguration(id, model);
        if (result.status === 201) {
          this.dialog = false;
          this.configurations = await this.getConfigurations();
        }
      },
      async submitUpdate(model) {
        const result = await this.updateConfiguration(model);
        if (result.status === 204) {
          this.dialog = false;
          this.configurations = await this.getConfigurations();
        }
      },
      serviceRequirementsForConfiguration(configuration) {
        return this.serviceRequirements.filter(r => configuration.serviceRequirements.find(v => v === r.id));
      },
      containerSizesForConfiguration(configuration) {
        return this.containerSizes.filter(x => configuration.containerSizes.find(v => v === x.id));
      },
    },
    async mounted() {
      this.configurations = await this.getConfigurations();
      this.serviceRequirements = await this.getServiceRequirements();
      this.containerSizes = await this.getContainerSizes();

      if (this.userIsFleetManager) {
        this.headers.push({value: 'id'}); // add edit column
      }
    }
  };
</script>
